// src/Step6Measurements.jsx
import React from 'react';

export default function Step6Measurements({ form, setMeasurement, colors }) {
  const measurements = form.measurements || {};

  return (
    <div>
      <SectionIntro
        colors={colors}
        title="اندازه‌های بدن"
        subtitle="این مرحله اختیاریه. اگر اندازه‌ها رو وارد کنی، پیگیری تغییرات بدن و تحلیل برنامه‌های بعدی دقیق‌تر می‌شه."
      />

      <div className="grid md:grid-cols-2 gap-4">
        <MeasurementInput
          label="دور شکم"
          hint="مهم برای پیگیری کاهش چربی"
          value={measurements.waist}
          onChange={(v) => setMeasurement('waist', normalizeNumber(v))}
          colors={colors}
        />

        <MeasurementInput
          label="دور بازو"
          hint="مناسب پیگیری رشد عضله"
          value={measurements.arm}
          onChange={(v) => setMeasurement('arm', normalizeNumber(v))}
          colors={colors}
        />

        <MeasurementInput
          label="دور ران"
          hint="برای تغییرات پایین‌تنه"
          value={measurements.thigh}
          onChange={(v) => setMeasurement('thigh', normalizeNumber(v))}
          colors={colors}
        />

        <MeasurementInput
          label="دور سینه"
          hint="برای بررسی تغییرات بالاتنه"
          value={measurements.chest}
          onChange={(v) => setMeasurement('chest', normalizeNumber(v))}
          colors={colors}
        />

        <MeasurementInput
          label="دور باسن"
          hint="برای تمرکز پا و باسن"
          value={measurements.hip}
          onChange={(v) => setMeasurement('hip', normalizeNumber(v))}
          colors={colors}
        />
      </div>

      <div
        className="mt-5 rounded-2xl border px-4 py-3 text-sm leading-7"
        style={{
          borderColor: colors.border,
          backgroundColor: 'rgba(37,99,235,0.08)',
          color: colors.sub,
        }}
      >
        وارد کردن این بخش اجباری نیست. اگر اندازه‌ای رو نمی‌دونی، خالی بذار و ادامه بده.
      </div>
    </div>
  );
}

function SectionIntro({ title, subtitle, colors }) {
  return (
    <div
      className="mb-5 rounded-2xl border p-4"
      style={{
        borderColor: colors.border,
        backgroundColor: 'rgba(255,255,255,0.03)',
      }}
    >
      <h3 className="text-lg md:text-xl font-black mb-2">{title}</h3>
      <p className="text-sm leading-7" style={{ color: colors.sub }}>
        {subtitle}
      </p>
    </div>
  );
}

function MeasurementInput({ label, hint, value, onChange, colors }) {
  return (
    <div
      className="rounded-[22px] border p-4"
      style={{
        borderColor: colors.border,
        backgroundColor: colors.inputBg,
      }}
    >
      <label className="block text-sm font-black mb-2">
        {label}
      </label>

      <div className="relative">
        <input
          type="tel"
          inputMode="numeric"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="اختیاری"
          className="w-full rounded-2xl border px-4 py-4 pl-16 outline-none text-right transition focus:border-blue-500"
          style={{
            backgroundColor: 'rgba(255,255,255,0.03)',
            borderColor: colors.border,
            color: colors.text,
          }}
        />

        <span
          className="absolute left-4 top-1/2 -translate-y-1/2 text-xs font-bold"
          style={{ color: colors.muted }}
        >
          cm
        </span>
      </div>

      <div className="mt-2 text-xs leading-6" style={{ color: colors.muted }}>
        {hint}
      </div>
    </div>
  );
}

function normalizeNumber(value) {
  return String(value || '')
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
    .replace(/[^\d]/g, '');
}